import { render } from "./ObjectSettings.vue?vue&type=template&id=6b4db46d&scoped=true"
import script from "./ObjectSettings.vue?vue&type=script&lang=js"
export * from "./ObjectSettings.vue?vue&type=script&lang=js"

import "./ObjectSettings.vue?vue&type=style&index=0&id=6b4db46d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4db46d"]])

export default __exports__